import { ref } from "vue";

export const openStatesHappy = ref<boolean[]>([])